import { Question, QuestionTypeEnum } from '@/types/survey';

// Update the Chinese questions to match the new structure
const zhQuestions: Question[] = [
  // Section 1: Business Goals and Strategy
  {
    id: 1,
    text: "您的商业项目的主要目标是什么？",
    type: QuestionTypeEnum.RADIO,
    category: "strategy",
    required: true,
    options: ["增加收入", "扩大市场份额", "提高客户满意度", "提高运营效率"],
    sectionHeader: "第1部分：业务目标和战略",
    weight: 1.5
  },
  {
    id: 2,
    text: "您对当前的业务战略满意度如何？",
    type: QuestionTypeEnum.LIKERT,
    category: "strategy",
    required: true,
    scale: 5,
    tooltip: "评价您对当前业务战略的满意程度",
    weight: 1.0
  },
  {
    id: 3,
    text: "您目前在业务中面临哪些挑战？",
    type: QuestionTypeEnum.TEXT,
    category: "strategy",
    required: true,
    tooltip: "描述您业务中当前面临的主要挑战",
    weight: 1.2
  },

  // Section 2: Emotional Metrics (NEV Components)
  {
    id: 4,
    text: "您如何评价您品牌的情感吸引力？",
    type: QuestionTypeEnum.LIKERT,
    category: "ea",
    required: true,
    scale: 5,
    tooltip: "评价品牌引起情感共鸣的能力",
    sectionHeader: "第2部分：情感指标（NEV组成部分）",
    weight: 2.0 // Higher weight for EA category
  },
  {
    id: 5,
    text: "您如何评价客户的忠诚度？",
    type: QuestionTypeEnum.LIKERT,
    category: "ea",
    required: true,
    scale: 5,
    tooltip: "评价客户对您品牌的忠诚度",
    weight: 1.8
  },
  {
    id: 6,
    text: "您如何评价与团队的情感联系？",
    type: QuestionTypeEnum.LIKERT,
    category: "l",
    required: true,
    scale: 5,
    tooltip: "评价团队内部的情感联系强度",
    weight: 1.5
  },
  {
    id: 7,
    text: "您如何评价产品/服务的情感共鸣？",
    type: QuestionTypeEnum.LIKERT,
    category: "elv",
    required: true,
    scale: 5,
    tooltip: "评价产品或服务与客户产生情感共鸣的程度",
    weight: 1.7
  },
  {
    id: 8,
    text: "您使用什么策略来情感上吸引客户？",
    type: QuestionTypeEnum.TEXT,
    category: "ea",
    required: true,
    tooltip: "描述您用于建立客户情感连接的策略",
    weight: 1.5
  },

  // Section 3: Financial Metrics (EROI Components)
  {
    id: 9,
    text: "您在商业项目中的总投资是多少？",
    type: QuestionTypeEnum.RADIO,
    category: "bc",
    required: true,
    options: ["低于10万美元", "10万至50万美元", "50万至100万美元", "超过100万美元"],
    sectionHeader: "第3部分：财务指标（EROI组成部分）",
    weight: 1.2
  },
  {
    id: 10,
    text: "您对此项目的预期投资回报率(ROI)是多少？",
    type: QuestionTypeEnum.RADIO,
    category: "bc",
    required: true,
    options: ["低于10%", "10%至20%", "20%至30%", "超过30%"],
    weight: 1.3
  },
  {
    id: 11,
    text: "您如何评价您业务的财务稳定性？",
    type: QuestionTypeEnum.LIKERT,
    category: "bc",
    required: true,
    scale: 5,
    tooltip: "评价您业务的财务健康状况",
    weight: 1.4
  },
  {
    id: 12,
    text: "您目前面临哪些主要的财务风险？",
    type: QuestionTypeEnum.TEXT,
    category: "bc",
    required: true,
    tooltip: "描述您业务中的主要财务风险",
    weight: 1.2
  },

  // Section 4: Operational Metrics
  {
    id: 13,
    text: "您如何评价您的运营效率？",
    type: QuestionTypeEnum.LIKERT,
    category: "tb",
    required: true,
    scale: 5,
    tooltip: "评价您业务运营的效率水平",
    sectionHeader: "第4部分：运营指标",
    weight: 1.3
  },
  {
    id: 14,
    text: "您如何评价您业务的创新水平？",
    type: QuestionTypeEnum.RATING,  // New question type
    category: "tb",
    required: true,
    scale: 5,
    tooltip: "评价您业务的创新能力",
    weight: 1.6
  },
  {
    id: 15,
    text: "您如何评价您业务模式的可扩展性？",
    type: QuestionTypeEnum.LIKERT,
    category: "elv",
    required: true,
    scale: 5,
    tooltip: "评价您业务模式的可扩展性",
    weight: 1.7
  },
  {
    id: 16,
    text: "您希望在未来12个月内实施哪些运营改进？",
    type: QuestionTypeEnum.TEXT,
    category: "tb",
    required: true,
    tooltip: "描述您计划进行的运营改进",
    weight: 1.1
  },

  // Section 5: Market and Customer Metrics
  {
    id: 17,
    text: "您如何评价市场对您产品/服务的需求？",
    type: QuestionTypeEnum.LIKERT,
    category: "elv",
    required: true,
    scale: 5,
    tooltip: "评价市场对您产品或服务的需求水平",
    sectionHeader: "第5部分：市场和客户指标",
    weight: 1.8
  },
  {
    id: 18,
    text: "您如何评价客户满意度水平？",
    type: QuestionTypeEnum.LIKERT,
    category: "ea",
    required: true,
    scale: 5,
    tooltip: "评价客户对您产品或服务的满意程度",
    weight: 1.9
  },
  {
    id: 19,
    text: "您采取哪些措施来提高客户保留率？",
    type: QuestionTypeEnum.TEXT,
    category: "ea",
    required: true,
    tooltip: "描述您提高客户保留率的策略",
    weight: 1.6
  }
];

// The English version of the questions with the new structure
const enQuestions: Question[] = [
  // Section 1: Business Goals and Strategy
  {
    id: 1,
    text: "What is the primary goal of your business project?",
    type: QuestionTypeEnum.RADIO,
    category: "strategy",
    required: true,
    options: ["Increase revenue", "Expand market share", "Improve customer satisfaction", "Enhance operational efficiency"],
    sectionHeader: "Section 1: Business Goals and Strategy",
    weight: 1.5,
    benchmark: {
      industry: {
        'Technology': 4.2,
        'Finance': 4.0,
        'Retail': 3.8
      }
    }
  },
  {
    id: 2,
    text: "How satisfied are you with your current business strategy?",
    type: QuestionTypeEnum.LIKERT,
    category: "strategy",
    required: true,
    scale: 5,
    tooltip: "Rate your satisfaction with your current business strategy",
    weight: 1.0
  },
  {
    id: 3,
    text: "What challenges are you currently facing in your business?",
    type: QuestionTypeEnum.TEXT,
    category: "strategy",
    required: true,
    tooltip: "Describe the main challenges you are currently facing in your business",
    weight: 1.2
  },

  // Section 2: Emotional Metrics (NEV Components)
  {
    id: 4,
    text: "How would you rate the emotional appeal of your brand?",
    type: QuestionTypeEnum.LIKERT,
    category: "ea",
    required: true,
    scale: 5,
    tooltip: "Rate how well your brand creates emotional connections",
    sectionHeader: "Section 2: Emotional Metrics (NEV Components)",
    weight: 2.0, // Higher weight for EA category
    benchmark: {
      industry: {
        'Technology': 3.8,
        'Entertainment': 4.5,
        'Retail': 4.0
      }
    }
  },
  {
    id: 5,
    text: "How would you rate the loyalty quotient of your customers?",
    type: QuestionTypeEnum.LIKERT,
    category: "ea",
    required: true,
    scale: 5,
    tooltip: "Rate your customer loyalty levels",
    weight: 1.8
  },
  {
    id: 6,
    text: "How would you rate the emotional connection with your team?",
    type: QuestionTypeEnum.LIKERT,
    category: "l",
    required: true,
    scale: 5,
    tooltip: "Rate the strength of emotional connections within your team",
    weight: 1.5
  },
  {
    id: 7,
    text: "How would you rate the emotional resonance of your products/services?",
    type: QuestionTypeEnum.LIKERT,
    category: "elv",
    required: true,
    scale: 5,
    tooltip: "Rate how well your products or services create emotional resonance",
    weight: 1.7
  },
  {
    id: 8,
    text: "What strategies do you use to emotionally engage your customers?",
    type: QuestionTypeEnum.TEXT,
    category: "ea",
    required: true,
    tooltip: "Describe the strategies you use to build emotional connections with customers",
    weight: 1.5
  },

  // Section 3: Financial Metrics (EROI Components)
  {
    id: 9,
    text: "What is the total investment you have made in your business project?",
    type: QuestionTypeEnum.RADIO,
    category: "bc",
    required: true,
    options: ["Less than $100,000", "$100,000 - $500,000", "$500,000 - $1,000,000", "More than $1,000,000"],
    sectionHeader: "Section 3: Financial Metrics (EROI Components)",
    weight: 1.2
  },
  {
    id: 10,
    text: "What is your expected return on investment (ROI) for this project?",
    type: QuestionTypeEnum.RADIO,
    category: "bc",
    required: true,
    options: ["Less than 10%", "10% - 20%", "20% - 30%", "More than 30%"],
    weight: 1.3
  },
  {
    id: 11,
    text: "How would you rate the financial stability of your business?",
    type: QuestionTypeEnum.LIKERT,
    category: "bc",
    required: true,
    scale: 5,
    tooltip: "Rate the financial health of your business",
    weight: 1.4,
    benchmark: {
      industry: {
        'Finance': 4.5,
        'Technology': 3.5,
        'Retail': 3.2
      }
    }
  },
  {
    id: 12,
    text: "What are the key financial risks you are currently facing?",
    type: QuestionTypeEnum.TEXT,
    category: "bc",
    required: true,
    tooltip: "Describe the main financial risks in your business",
    weight: 1.2
  },

  // Section 4: Operational Metrics
  {
    id: 13,
    text: "How would you rate the efficiency of your operations?",
    type: QuestionTypeEnum.LIKERT,
    category: "tb",
    required: true,
    scale: 5,
    tooltip: "Rate the efficiency level of your business operations",
    sectionHeader: "Section 4: Operational Metrics",
    weight: 1.3
  },
  {
    id: 14,
    text: "How would you rate the innovation level of your business?",
    type: QuestionTypeEnum.RATING,  // New question type
    category: "tb",
    required: true,
    scale: 5,
    tooltip: "Rate your business's innovation capabilities",
    weight: 1.6,
    benchmark: {
      industry: {
        'Technology': 4.3,
        'Web 3.0': 4.7,
        'Manufacturing': 3.8
      }
    }
  },
  {
    id: 15,
    text: "How would you rate the scalability of your business model?",
    type: QuestionTypeEnum.LIKERT,
    category: "elv",
    required: true,
    scale: 5,
    tooltip: "Rate how scalable your business model is",
    weight: 1.7
  },
  {
    id: 16,
    text: "What operational improvements would you like to implement in the next 12 months?",
    type: QuestionTypeEnum.TEXT,
    category: "tb",
    required: true,
    tooltip: "Describe the operational improvements you plan to implement",
    weight: 1.1
  },

  // Section 5: Market and Customer Metrics
  {
    id: 17,
    text: "How would you rate the market demand for your products/services?",
    type: QuestionTypeEnum.LIKERT,
    category: "elv",
    required: true,
    scale: 5,
    tooltip: "Rate the level of market demand for your products or services",
    sectionHeader: "Section 5: Market and Customer Metrics",
    weight: 1.8
  },
  {
    id: 18,
    text: "How would you rate the customer satisfaction level?",
    type: QuestionTypeEnum.LIKERT,
    category: "ea",
    required: true,
    scale: 5,
    tooltip: "Rate your customer satisfaction levels",
    weight: 1.9,
    benchmark: {
      industry: {
        'Technology': 4.0,
        'Retail': 4.2,
        'Healthcare': 4.3
      }
    }
  },
  {
    id: 19,
    text: "What steps are you taking to improve customer retention?",
    type: QuestionTypeEnum.TEXT,
    category: "ea",
    required: true,
    tooltip: "Describe your strategies for improving customer retention",
    weight: 1.6
  }
];

// The rest of the file remains the same
export const getQuestions = (language: string): Question[] => {
  return language === 'zh' ? zhQuestions : enQuestions;
};

export const questions = enQuestions;
